var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3618_19568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.52343 2.52673L5.95312 2.09705C6.12223 1.92789 6.32301 1.7937 6.54399 1.70215C6.76497 1.6106 7.00182 1.56348 7.24101 1.56348C7.4802 1.56348 7.71705 1.6106 7.93803 1.70215C8.15901 1.7937 8.35979 1.92789 8.5289 2.09705C8.69806 2.26616 8.83225 2.46694 8.9238 2.68791C9.01535 2.90889 9.06247 3.14574 9.06247 3.38494C9.06247 3.62413 9.01535 3.86098 8.9238 4.08196C8.83225 4.30294 8.69806 4.50372 8.5289 4.67283L7.57656 5.62517L7.17265 6.02908C7.00334 6.19841 6.8023 6.3327 6.58104 6.42426C6.35978 6.51583 6.12264 6.56286 5.88318 6.56268C5.64372 6.5625 5.40665 6.5151 5.18553 6.42321C4.96441 6.33131 4.76358 6.19672 4.59452 6.02712C4.41954 5.85221 4.28216 5.64337 4.1908 5.41344C4.09944 5.1835 4.05605 4.93733 4.06327 4.69001",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.47657 7.47341L4.04689 7.9031C3.87758 8.07244 3.67654 8.20673 3.45528 8.29829C3.23402 8.38985 2.99688 8.43689 2.75742 8.4367C2.51796 8.43652 2.28089 8.38913 2.05977 8.29723C1.83864 8.20533 1.63781 8.07074 1.46876 7.90115C1.12813 7.55933 0.937061 7.09631 0.937501 6.61375C0.93794 6.13118 1.12985 5.66852 1.4711 5.32732L2.82735 3.97107C2.99647 3.80191 3.19724 3.66772 3.41822 3.57617C3.6392 3.48462 3.87605 3.4375 4.11525 3.4375C4.35444 3.4375 4.59129 3.48462 4.81227 3.57617C5.03325 3.66772 5.23402 3.80191 5.40314 3.97107C5.57884 4.14597 5.71684 4.35503 5.80861 4.58534C5.90039 4.81565 5.94399 5.06232 5.93673 5.31013",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3618_19568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.e2dfcde1a74381377c579e3552fc7780.svg";
export { ForwardRef as ReactComponent };